import Ajax from "base/Ajax";
import Message from "base/Message";
import ConfirmModal from "modal/ConfirmModal";
import AjaxForm, { EVENT_SUCCESS } from "webPage/AjaxForm";
import Page from "webPage/Page";

Page.register(new RegExp('^/customers/([0-9a-f]+)/invoices/([0-9a-f]+)/?$'), ([customer_id, invoice_id]) => {
    let form = new AjaxForm($(".container"), ($form, formData) => {
        return Ajax.post("billing", "invoices/" + invoice_id, $.extend({customer: customer_id}, formData));
    });

    form.on(EVENT_SUCCESS, (data) => {
        Message.schedule(new Message('The invoice has been updated successfully', 'Invoice updated', Message.SUCCESS));
        window.location.reload();
        return false;
    });

    $("body").on("click", ".js-dismiss-po-warning", function () {
        let modal = new ConfirmModal("Are you sure you want to dismiss the missing Purchase Order?", undefined, {
            showLoading: true,
        });
        modal.on("confirm", async () => {
            if (modal.isLoading()) {
                return false;
            }
            modal.showLoading();

            try {
                await Ajax.post("billing", "invoices/" + invoice_id + "/dismiss-po-warning");
                window.location.reload();
            } catch (e) {
                new Message(e.message, "An error occurred");
                modal.stopLoading();
            }
        }).on("cancel", () => {
            if (modal.isLoading()) {
                return false;
            }
            modal.destroy();
        });
        modal.show();
        return false;
    });
});
